import React from 'react';
import { ScanLine } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-2571" data-mp="3ggaq1tbg494e">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2572" data-mp="32onj8zjvni7d">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-2573" data-mp="32m1c310wf4po">
          <div className="col-span-1 md:col-span-2" data-id="element-2574" data-mp="36q94b86kf2sn">
            <Link to="/" className="flex items-center space-x-2 mb-4 group" data-id="element-2575" data-mp="3ufa4y995p9nd">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vxdue6obzwd6hjhd7fonaj/c2dc3655-bf08-4072-907a-0e44a0f2759c/intellieats_icon.webp" alt="IntelliEats icon" className="h-8 w-8 rounded-lg shadow-lg group-hover:shadow-brand-500/20 transition-all duration-300" data-id="element-2576" data-mp="3ud7g3sjqpmk8" />
              
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-2577" data-mp="29zglw3w5synp">
                Intelli<span className="text-brand-500" data-id="element-2578" data-mp="2a1ji55nwno0v">Eats</span>
              </span>
            </Link>
            <p className="text-sm max-w-xs leading-relaxed" data-id="element-2579" data-mp="2evxb71f3hj2d">
              Empowering you to make healthier food choices through intelligent
              ingredient analysis. Scan, detect, and eat smarter.
            </p>
          </div>

          <div data-id="element-2580" data-mp="3v7zvpch5iql7">
            <h3 className="text-white font-bold mb-4" data-id="element-2581" data-mp="3v8hp81cfiqpf">Product</h3>
            <ul className="space-y-2 text-sm" data-id="element-2582" data-mp="3q83tnis0l98a">
              <li data-id="element-2583" data-mp="3q7bvq1ay2zeu">
                <a href="/#how-it-works" className="hover:text-brand-400 transition-colors" data-id="element-2584" data-mp="3qazrz87rxzx9">
                  
                  How It Works
                </a>
              </li>
              <li data-id="element-2585" data-mp="33nna8afjnlr">
                <a href="/#features" className="hover:text-brand-400 transition-colors" data-id="element-2586" data-mp="3231b726lczi">
                  
                  Features
                </a>
              </li>
              <li data-id="element-2587" data-mp="cu8qya4ynibj">
                <Link to="/blog" className="hover:text-brand-400 transition-colors" data-id="element-2588" data-mp="cw33p162w44j">
                  
                  Blog
                </Link>
              </li>
              <li data-id="element-2589" data-mp="mt7vbgip0rsq">
                <a href="/#download" className="hover:text-brand-400 transition-colors" data-id="element-2590" data-mp="mptp1x6wryg0">
                  
                  Download
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-2591" data-mp="ys3gsil2z725">
            <h3 className="text-white font-bold mb-4" data-id="element-2592" data-mp="13tao6gjba48a">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-2593" data-mp="13rpoydm1xx43">
              <li data-id="element-2594" data-mp="18jr2s3yvbvw8">
                <Link to="/privacy" className="hover:text-brand-400 transition-colors" data-id="element-2595" data-mp="18k98dr7f7mgt">
                  
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-2596" data-mp="1hk5yzyddevei">
                <Link to="/terms" className="hover:text-brand-400 transition-colors" data-id="element-2597" data-mp="1hjnuyfkgvcw1">
                  
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-2598" data-mp="1rjeoadxajluj">
                <Link to="/editorial-policy" className="hover:text-brand-400 transition-colors" data-id="element-2599" data-mp="1rhtw2uyg8ezu">
                  
                  Editorial Policy
                </Link>
              </li>
              <li data-id="element-2600" data-mp="3t9gggdnu5bnc">
                <Link to="/contact" className="hover:text-brand-400 transition-colors" data-id="element-2601" data-mp="3tb1bs5hz4ym9">
                  
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-2602" data-mp="25mao12bk1v7j">
          <p data-id="element-2603" data-mp="1wnp5h7632g6r">© {new Date().getFullYear()} IntelliEats. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-2604" data-mp="1wlmbkc1t82wr">Developed by IntelliEats Team</p>
        </div>
      </div>
    </footer>;
}